module.exports = __webpack_public_path__ + "img/cat-outline-partial.edc1b1af.png";